export const translations = {
  sv: {
    nav: {
      howItWorks: "Så Fungerar Det",
      admin: "Admin",
      getEarlyAccess: "Få Förtur",
      joinNewsletter: "Gå med i nyhetsbrevet",
    },
    home: {
      heroBadgeLine1: "B2B Marknadsplats",
      heroBadgeLine2: "Köp & Sälj Sorterad Secondhand & Restlager i Bulk",
      heroTitle1: "Köp & Sälj",
      heroTitle2: "Sorterad Secondhand &",
      heroTitle3: "Restlager",
      heroTitle4: "i Bulk",
      heroCtaLearn: "Så Fungerar Det",
      heroCtaAccess: "Få Förtur",
      description: "En marknadsplats som kopplar samman modevarumärken och sorteringsanläggningar med innovativa redesigners och upcycling-varumärken. Köp och sälj sorterad secondhand i bulk och restlager, anonymt om du vill, eller publicera remake-projekt för att omvandla överskottsmaterial till framtidens mode.",
      whatWeOffer: "Vad Vi Erbjuder",
      whatWeDo: "Vad Vi Gör",
      whatWeOfferDesc: "En strömlinjeformad plattform som kopplar samman de som har överskottsmaterial med de som omvandlar dem.",
      tabBrowseFull: "Köp & Sälj Secondhand & Deadstock",
      tabBrowseShort: "Köp & Sälj",
      tabRemakePrefix: "",
      tabRemake: "Skapa Remake Collabs",
      marketplaceBadge: "Marknadsplats",
      marketplaceTitle: "Köp & Sälj Sorterad Secondhand & Deadstock-Plagg",
      marketplaceDesc: "En marknadsplats där varumärken och sorteringsanläggningar listar sitt restlager, och redesigners bläddrar och köper material i bulk för att skala upp sina kreativa projekt.",
      forSellers: "För Varumärken & Sorteringsanläggningar",
      forSellersDesc: "Lista ditt reslager, deadstock-plagg anonymt för varumärkesskydd eller lista din sorterade secondhand, för bulkförsäljning. Omvandla restlager till intäkter och bidra till hållbart mode på riktigt.",
      sellerBenefit1: "Sälj anonymt för varumärkesskydd",
      sellerBenefit2: "Tjäna pengar på material som annars skulle gå till spillo",
      sellerBenefit3: "Verifierade köpare, spårbart",
      forBuyers: "För Redesigners & Upcyclers",
      forBuyersDesc: "Få tillgång till stora mängder material och plagg för dina kreativa projekt. Sourca hållbart och spara tid.",
      buyerBenefit1: "Sorterad secondhand & deadstock-plagg i Bulk",
      buyerBenefit2: "Svenskt material med detaljerade specifikationer",
      buyerBenefit3: "Tydlig skickklassificering",
      projectBadge: "Projektsamarbete",
      projectTitle: "Skapa Remake Collabs",
      projectDesc: "Varumärken publicerar RFP:er för att omvandla sin secondhand & deadstock till nya kollektioner, och skickliga remakers budar på projekt för att förverkliga dem.",
      forBrandsPosting: "För Varumärken som Publicerar Projekt",
      forBrandsPostingDesc: "Publicera remake-projekt för att anlita skickliga remakers och upcyclers att omvandla din secondhand & deadstock till nya kollektioner och unika plagg.",
      brandBenefit1: "Publicera detaljerade RFP:er för remake-samarbeten",
      brandBenefit2: "Tillgång till nätverk av skickliga redesigners",
      brandBenefit3: "Omvandla misslyckade produktioner till framtidens mode",
      forRemakers: "För Remakers & Upcyclers",
      forRemakersDesc: "Bläddra bland tillgängliga remake-projekt och buda på möjligheter att omvandla secondhand & deadstock till nya modeplagg.",
      remakerBenefit1: "Bläddra och buda på remake-projekt",
      remakerBenefit2: "Direktsamarbete med stora varumärken",
      remakerBenefit3: "Visa upp dina kunskaper och väx ditt företag",
      howItWorksTitle: "Så Fungerar Det",
      howItWorksSubtitle: "För Redesigners, Upcyclers & Institutionella Köpare",
      howItWorksDesc: "En enkel trestegsprocess för att koppla samman utbud med efterfrågan.",
      step1Title: "Registrera Dig",
      step1Desc: "Skapa ditt konto som säljare eller köpare. Varumärken? Vi guidar dig genom en snabb, enkel setup.",
      step2Title: "Lista eller Bläddra",
      step2Desc: "Säljare listar material med foton och specifikationer. Köpare bläddrar och hittar vad de behöver.",
      step3Title: "Handla & Skickas",
      step3Desc: "Säkra transaktioner, materielt skickas och alla bidrar till morgondagens modebransch <3",
      learnMore: "Så fungerar HIDNstock",
      ctaTitle: "Få Förtur",
      ctaDesc: "Bli först med att veta när HIDNstock lanseras. Registrera dig för att få uppdateringar och exklusiv förtur.",
      ctaButton: "Registrera Dig Nu",
      ctaPrivacy: "Vi respekterar din integritet. Avregistrera dig när som helst.",
      requestTitle: "Sälj eller hitta material",
      requestSubtitle: "Oavsett om du vill lista överskottsmaterial eller letar efter något specifikt — vi matchar dig.",
      requestPlaceholder: "T.ex. 500 kg deadstock denim, eller letar efter sorterade secondhand t-shirts i bulk...",
      requestEmailPlaceholder: "Din e-postadress",
      requestIntentLabel: "Jag vill",
      requestIntentSource: "Hitta material",
      requestIntentSell: "Sälja material",
      requestGdpr: "Jag godkänner att min e-post och förfrågan sparas. Vi kontaktar dig bara vid matchning. Du kan avregistrera dig när som helst.",
      requestButton: "Sälj eller hitta material",
      requestDisclaimer: "Vi mailar bara när vi hittar en match – ingen spam, inga omvägar.",
      requestSuccess: "Bra drag. 👊",
      requestSuccessDesc: "Vi hör av oss när vi hittar en match.",
      requestError: "Något gick fel. Försök igen.",
    },
    howItWorks: {
      badgeLine1: "B2B Plattform",
      badgeLine2: "Sorterad secondhand & restlager",
      title: "Så Fungerar HIDNstock",
      subtitle: "En plattform, två tjänster. Välj den väg som passar dina behov.",
      tabBrowseTitle: "Köp & Sälj",
      tabBrowseSub: "Secondhand & Deadstock",
      tabRemakeTitle: "Skapa Remake",
      tabRemakeSub: "Collabs",
      marketplaceBadge: "Marknadsplats",
      marketplaceTitle: "Köp & Sälj Sorterad Secondhand & Deadstock-Plagg",
      marketplaceDesc: "En marknadsplats där varumärken och sorteringsanläggningar listar sitt restlager, och redesigners bläddrar och köper material.",
      iWantToSell: "Jag Vill Sälja",
      iWantToBuy: "Jag Vill Köpa",
      sellersTitle: "För Varumärken & Sorteringsanläggningar",
      sellersDesc: "Omvandla restlager till intäkter och stöd hållbarhet",
      sellStep1Title: "Skapa Ditt Konto",
      sellStep1Desc: "Registrera dig och verifiera ditt företag. Välj om du vill lista anonymt eller visa ditt varumärke.",
      sellStep2Title: "Lista Dina Material",
      sellStep2Desc: "Med en enkel integration och ett klick, ladda upp foton och specifikationer av din sorterade secondhand eller deadstock-plagg. Ange antal och prissättning.",
      sellStep3Title: "Anslut & Sälj",
      sellStep3Desc: "Sälj till verifierade köpare. Få tillförlitlig data för din hållbarhetsrapport och omvandla avfall till intäkter.",
      sellBenefit1: "Tjäna pengar på material som annars skulle gå till spillo",
      sellBenefit2: "Valfri anonymitet för varumärkesskydd",
      sellBenefit3: "Bevara ditt varumärkes status",
      sellBenefit4: "Dokumentation av hållbarhetspåverkan",
      buyersTitle: "För Redesigners & Upcyclers",
      buyersDesc: "Tillgång till bulkmaterial för dina kreativa projekt",
      buyStep1Title: "Skapa Ditt Konto",
      buyStep1Desc: "Registrera dig som köpare och berätta om ditt företag och vilka typer av material du letar efter.",
      buyStep2Title: "Bläddra & Upptäck",
      buyStep2Desc: "Sök bland tillgängliga listor. Filtrera efter materialtyp, antal, skick och plats.",
      buyStep3Title: "Anslut & Köp",
      buyStep3Desc: "Köp från verifierade säljare, spara tid och kostnad och säkra materialen du behöver för dina projekt.",
      buyBenefit1: "Bulktillgång till kvalitetsmaterial",
      buyBenefit2: "Spara tid på sourcing",
      buyBenefit3: "Köp från verifierade säljare",
      buyBenefit4: "Verifierade materialspecifikationer",
      projectBadge: "Projektsamarbete",
      projectTitle: "Skapa Remake Collabs",
      projectDesc: "Varumärken postar RFP:s för att omvandla sitt restlager till nya kollektioner, och kreativa remakers budar på projekt.",
      iWantToPost: "Posta Remake Projekt",
      iWantToBid: "Jag Vill Buda",
      brandsTitle: "För Varumärken som Publicerar Projekt",
      brandsDesc: "Omvandla din secondhand & deadstock till nya kollektioner",
      postStep1Title: "Skapa Ditt Projekt",
      postStep1Desc: "Beskriv din secondhand & deadstock, mängden tillgänglig och din vision för remake-projektet.",
      postStep2Title: "Motta Bud",
      postStep2Desc: "Skickliga remakers och upcyclers skickar förslag med sina kreativa idéer och prissättning.",
      postStep3Title: "Samarbeta & Skapa",
      postStep3Desc: "Välj din föredragna remaker, slutför villkoren och arbeta tillsammans för att skapa nya modeplagg.",
      postBenefit1: "Omvandla misslyckade produktioner till nya kollektioner",
      postBenefit2: "Tillgång till skickliga remake-professionella",
      postBenefit3: "Kontrollera den kreativa riktningen",
      postBenefit4: "Hållbar lösning för restlager",
      remakersTitle: "För Remakers & Upcyclers",
      remakersDesc: "Buda på projekt och väx ditt företag",
      bidStep1Title: "Bläddra Bland Projekt",
      bidStep1Desc: "Utforska tillgängliga remake-projekt från varumärken som vill omvandla sin secondhand & deadstock.",
      bidStep2Title: "Skicka Ditt Bud",
      bidStep2Desc: "Föreslå din kreativa vision, tidslinje och prissättning för projektet.",
      bidStep3Title: "Vinn & Leverera",
      bidStep3Desc: "Om du väljs, samarbeta med varumärket för att förverkliga din kreativa vision.",
      bidBenefit1: "Direkt tillgång till varumärkessamarbeten",
      bidBenefit2: "Stadigt flöde av projektmöjligheter",
      bidBenefit3: "Spara tid på säljmöten",
      bidBenefit4: "Bygg din professionella portfölj",
      benefits: "Fördelar",
      trustTitle: "Byggt på Förtroende",
      trustDesc: "Varje transaktion på HIDNstock är designad med säkerhet och transparens i åtanke. Verifierade konton, säker kommunikation och tydliga villkor skyddar alla parter.",
    },
    about: {
      title: "Om HIDNstock",
      subtitle: "Bygger B2B-infrastruktur för cirkulära textilier",
      metaTitle: "Om HIDNstock - B2B Marknadsplats för Cirkulära Textilier",
      metaDesc: "HIDNstock grundades för att överbrygga klyftan mellan deadstock-material och cirkulära modeföretag. Läs om vårt uppdrag att skapa B2B-infrastruktur för hållbara textilier.",
      kicker: "Vårt manifest",
      hero: "Vi gör inte avfall. Vi gör värde.",
      lead: "HIDNstock föddes ur frustration. Vi har år bakom oss i modeindustrins skyttegravar — från designstudion till fabriksgolvet — och vi såg samma trasiga mönster överallt.",
      heading1: "Varför vi byggde detta",
      p1: "HIDNstock föddes ur frustration. Vi har spenderat år i modeindustrins skyttegravar — från designstudion till fabriksgolvet — och vi såg samma trasiga mönster överallt: stora varumärken och sorteringsanläggningar drunknar i osålt lager och högkvalitativ secondhand i bulk, medan talangfulla remakers och designers svälter efter material för att kunna skala.",
      p2: "Industrin sitter fast i en linjär loop, och ärligt talat — det är förlegat. Vi bestämde oss för att sluta klaga och börja bygga den infrastruktur som faktiskt kopplar samman dessa världar.",
      heading2: "Därför finns vi",
      p3: "Vi är ett team av modeveteraner och digitala arkitekter. Vi har sett på nära håll hur värdefulla textilier — oavsett om det är helt nytt deadstock från ett stort varumärke eller högkvalitativ secondhand i bulk från sorteringsanläggningar — ofta hamnar i förbränningen eller downcyclas, helt enkelt för att industrin saknar en professionell, skalbar marknadsplats. Materialet finns redan här; problemet har alltid varit avsaknaden av en bro.",
      bridge: "Så vi byggde den bron.",
      heading3: "HIDNstock-vägen",
      p4: "HIDNstock är B2B-ryggraden för cirkulära textilier. Vi flyttar överskottslager och sorterad bulk från ”skuld” till ”tillgång” — på ett sätt som är spårbart, varumärkessäkert och lönsamt.",
      p4b: "Vi tror inte på att bara ”återvinna” material ner till skrot. Vi tror på att hålla värdet vid liv. Oavsett om det är färdiga plagg, deadstock-tyg eller kurerad secondhand i bulk — vi ser till att det som redan producerats får ett andra liv hos någon som faktiskt kommer använda det.",
      heading4: "Framtiden är cirkulär",
      p5: "EU:s regelverk skiftar, och dagarna då osålda varor förbrändes är räknade. Varumärken och sorteringsanläggningar står inför ett enkelt val: anpassa er till en cirkulär verklighet eller bli omsprungna. Vi finns för dem som väljer att anpassa sig — innovatörerna som vet att modets framtid inte handlar om att producera mer, utan om att maximera briljansen i det vi redan har.",
      cta: "Häng med och bygg en mer motståndskraftig industri. En överskottsbatch i taget.",
    },
    contact: {
      title: "Kontakta Oss",
      subtitle: "Har du frågor? Vi vill gärna höra från dig.",
      getInTouch: "Hör Av Dig",
      getInTouchDesc: "Vi svarar så snart som möjligt.",
      name: "Namn *",
      namePlaceholder: "Ditt namn",
      email: "E-post *",
      emailPlaceholder: "din@epost.se",
      company: "Företag (valfritt)",
      companyPlaceholder: "Ditt företagsnamn",
      messageLbl: "Meddelande *",
      messagePlaceholder: "Berätta hur vi kan hjälpa dig...",
      sending: "Skickar...",
      sendMessage: "Skicka Meddelande",
      successTitle: "Meddelande skickat!",
      successDesc: "Tack för att du hör av dig. Vi återkommer så snart som möjligt.",
      errorTitle: "Fel",
      errorDesc: "Kunde inte skicka meddelande. Försök igen.",
    },
    footer: {
      description: "B2B-marknadsplatsen som kopplar samman varumärken och sorteringsanläggningar med redesigners och upcyclers genom secondhand- och deadstock-plagg.",
      platform: "Plattform",
      howItWorks: "Så Fungerar Det",
      whatDoesItMean: "Vad Betyder Det?",
      company: "Företag",
      aboutHidnstock: "Om HIDNstock",
      contact: "Kontakt",
      rights: "© 2025 HIDNstock. Alla rättigheter förbehållna.",
      tagline: "Omvandlar textilavfall till möjligheter",
      newsletter: "Nyhetsbrev",
      press: "Press",
    },
    newsletter: {
      title: "Vill du vara med på vårt kärleksbrev?",
      description: "Få tips om hur du skalar din remake-verksamhet, en sneak peek på de senaste listningarna, remake-inspo och de senaste HIDNstock-uppdateringarna direkt i din inkorg.",
      pageIntro: "Få tips om hur du skalar din remake-verksamhet, en sneak peek på de senaste listningarna, remake-inspo och de senaste HIDNstock-uppdateringarna direkt i din inkorg.",
      emailLabel: "E-post",
      emailPlaceholder: "din@epost.se",
      gdprText: "Jag godkänner att HIDNstock lagrar min e-post och skickar nyhetsbrev och tjänsteuppdateringar till mig. Jag kan avregistrera mig när som helst.",
      signingUp: "Registrerar...",
      signUp: "Prenumerera",
      privacyNote: "Vi respekterar din integritet. Din data hanteras enligt GDPR.",
      successTitle: "Tack!",
      successDesc: "Du är nu prenumerant på vårt nyhetsbrev.",
      close: "Stäng",
      alreadySignedUpTitle: "Redan registrerad",
      alreadySignedUpDesc: "Denna e-post finns redan på listan!",
      successToastTitle: "Klart!",
      successToastDesc: "Du är registrerad för nyhetsbrevet.",
      errorTitle: "Något gick fel",
      errorDesc: "Försök igen senare",
    },
    earlyAccess: {
      title: "Få Förtur",
      description: "Bli först med att veta när HIDNstock lanseras.",
      emailLabel: "E-post",
      emailPlaceholder: "din@epost.se",
      iAmA: "Jag är en...",
      brand: "Varumärke",
      sortingFacility: "Sorteringsanläggning",
      remakerUpcycler: "Remaker / Upcycler",
      gdprText: "Jag godkänner att HIDNstock lagrar min e-post och kontaktar mig om lanseringen och tjänsteuppdateringar. Jag kan avregistrera mig när som helst.",
      signingUp: "Registrerar...",
      signUp: "Registrera Dig",
      privacyNote: "Vi respekterar din integritet. Din data hanteras enligt GDPR.",
      successTitle: "Du Är På Listan!",
      successDesc: "Tack för att du registrerade dig. Vi hör av oss snart med uppdateringar.",
      close: "Stäng",
      alreadySignedUpTitle: "Redan registrerad",
      alreadySignedUpDesc: "Denna e-post finns redan på listan!",
      successToastTitle: "Klart!",
      successToastDesc: "Du är på listan! Kolla din inkorg för en bekräftelse.",
      errorTitle: "Något gick fel",
      errorDesc: "Försök igen senare",
    },
    whatDoesItMean: {
      badge: "Ordlista & Definitioner",
      title: "Vad Betyder Det?",
      subtitle: "Förstå terminologin inom hållbart mode och cirkulär textilekonomi. Lär dig vad deadstock, sorterad secondhand, upcycling och remake betyder i samband med vår B2B-marknadsplats.",
      b2bTitle: "B2B (Business-to-Business) plattform för hållbara textilier",
      b2bDesc1: "HIDNstock är en <strong>B2B (Business-to-Business)</strong> plattform designad exklusivt för transaktioner mellan företag — inte enskilda konsumenter. Vi möjliggör professionell, storskalig sourcing och återförsäljning av hållbara textilier inom mode- och textilindustrin.",
      b2bDesc2: "Vår plattform kopplar samman nyckelaktörer i den cirkulära modesupplychain:",
      b2bBullet1: "<strong>Modevarumärken</strong> med restlager, deadstock eller överproduktion",
      b2bBullet2: "<strong>Textilsorteringsanläggningar</strong> som bearbetar secondhand- och post-konsumentmaterial",
      b2bBullet3: "<strong>Redesigners och upcyclers</strong> som sourcar material för cirkulär och kreativ produktion",
      b2bBullet4: "<strong>Tillverkare</strong> som letar efter pålitliga, hållbara tyg- och materialkällor",
      b2bDesc3: "Genom att fokusera på B2B-textiltransaktioner möjliggör HIDNstock bulkvolymer, konsekventa kvalitetsstandarder, full materialspårbarhet och effektiv logistik. Detta skapar en skalbar infrastruktur för cirkulärt mode, textilåteranvändning och hållbar tillverkning.",
      deadstockTitle: "Vad är deadstock inom modeindustrin?",
      deadstockSubtitle: "Förstå Deadstock",
      deadstockAlias: "Även känt som: NOS, Gammalt Lager, Överlager, Överskottslager, Restlager",
      deadstockDesc: "<strong>Deadstock</strong> (även kallat överskottslager eller restlager) avser osålt lager, överblivna tyger eller färdiga plagg som aldrig såldes till konsumenter. Inom mode- och textilindustrin ackumuleras deadstock när:",
      deadstockReason1: "Varumärken producerar fler varor än vad marknaden efterfrågar",
      deadstockReason2: "Detaljhandelsordrar annulleras före eller efter produktion",
      deadstockReason3: "Säsongskollektioner inte säljs ut",
      deadstockReason4: "Tygbalar förblir oanvända efter produktionskörningar",
      complexityTitle: "Komplexiteten med deadstock",
      complexityDesc1: "Deadstock ses ofta som ett symptom på strukturella utmaningar i modeindustrin. Medan vissa hävdar att återförsäljning av deadstock riskerar att normalisera överproduktion, är verkligheten att betydande volymer redan existerar idag — och kommer att fortsätta göra det tills prognostisering, produktionsplanering och teknik för försörjningskedjor mognar ytterligare.",
      complexityDesc2: "Tills den övergången är klar representerar deadstock både en <strong>miljöutmaning</strong> och ett <strong>ansvar</strong>.",
      transitionalTitle: "HIDNstock som en övergångslösning",
      transitionalDesc1: "HIDNstock är byggt som en övergångslösning. Vår plattform syftar inte till att rättfärdiga överproduktion, utan att förhindra att befintliga material blir avfall. Genom att möjliggöra kontrollerad, spårbar B2B-omfördelning kan varumärken ta ansvar för restlager samtidigt som de stödjer cirkulära modepraxis.",
      transitionalDesc2: "Genom HIDNstock får varumärken möjlighet att:",
      transitionalBenefit1: "<strong>Monetarisera befintlig deadstock</strong> utan att späda ut sitt kärnvarumärke",
      transitionalBenefit2: "<strong>Minska miljöpåverkan</strong> genom att förlänga materialens livscykler",
      transitionalBenefit3: "<strong>Samarbeta med redesigners, remakers och upcyclers</strong> på nya kollektioner",
      transitionalBenefit4: "<strong>Omvandla överskottsmaterial</strong> till kreativt, hållbart värde",
      transitionalQuote: "Vår långsiktiga ambition är en modeindustri med minimal överproduktion. Tills dess tillhandahåller HIDNstock ett praktiskt, skalbart sätt att omvandla deadstock till en kraft för positiv förändring.",
      sortedTitle: "Sorterad Secondhand Förklarad",
      sortedSubtitle: "Vad är Sorterad Secondhand?",
      sortedBadge: "Professionella pre-owned textilier",
      sortedDesc: "<strong>Sorterad secondhand</strong> avser förbrukade plagg som har samlats in, inspekterats och kategoriserats av professionella sorteringsanläggningar. Till skillnad från slumpmässiga fynd på secondhand-butiker är sorterad secondhand:",
      categorizedBy: "Kategoriserad efter:",
      cat1: "Materialtyp (bomull, ull, denim, etc.)",
      cat2: "Plaggkategori (jackor, skjortor, byxor)",
      cat3: "Kvalitetsgrad (A, B, C)",
      cat4: "Färgfamilj",
      cat5: "Säsongslämplighet",
      benefitsFor: "Fördelar för B2B-köpare:",
      ben1: "Konsekvent kvalitet inom partier",
      ben2: "Bulkkvantiteter tillgängliga",
      ben3: "Tydlig skickgradering",
      ben4: "Minskad sourcingtid",
      ben5: "Förutsägbara materialegenskaper",
      sortedSummary: "På HIDNstock listar sorteringsanläggningar sitt bearbetade lager, vilket gör det möjligt för redesigners och upcyclers att effektivt sourca specifika typer av plagg i bulkkvantiteter — något som är nästan omöjligt genom traditionella secondhand-kanaler.",
      remakeTitle: "Remake, Redesign & Upcycling",
      whatIsRemake: "Vad är Remake?",
      remakeBadge: "Uppdragsbaserad transformation",
      remakeDesc: "<strong>Remake</strong> är processen där varumärken ger skickliga hantverkare eller företag i uppdrag att omvandla deras restlager till nya produkter. På HIDNstock:",
      remakePoint1: "Varumärken publicerar <strong>Remake-Projekt</strong> som beskriver deras material och vision",
      remakePoint2: "Kvalificerade remakers budar på dessa projekt med förslag",
      remakePoint3: "Valda remakers omvandlar materialen till nya modeplagg",
      remakePoint4: "Varumärken får unika nya produkter; remakers får betalt för sina kunskaper",
      remakeSummary: "Detta samarbetsbaserade tillvägagångssätt håller material i cirkulation och skapar värde för alla parter.",
      whatIsRedesign: "Vad är Redesign?",
      redesignBadge: "Kreativ nytolkning",
      redesignDesc: "<strong>Redesign</strong> innebär att ta befintliga plagg eller material och ge dem ett nytt designperspektiv. Redesigners:",
      redesignPoint1: "Dekonstruerar originalplagg för att skapa nya mönster",
      redesignPoint2: "Kombinerar flera källplagg till enskilda nya plagg",
      redesignPoint3: "Tillämpar nya tekniker (färgning, tryck, utsmyckning)",
      redesignPoint4: "Skapar begränsade upplagor eller unika plagg",
      redesignSummary: "Redesign överbryggar gapet mellan avfallsminskning och kreativt mode, och producerar unika plagg med övertygande hållbarhetsberättelser.",
      whatIsUpcycling: "Vad är Upcycling?",
      upcyclingBadge: "Värdeförhöjning",
      upcyclingDesc: "<strong>Upcycling</strong> är den kreativa processen att omvandla kasserade material eller oönskade produkter till nya föremål av <em>högre</em> kvalitet eller värde. Viktiga egenskaper:",
      upcyclingPoint1: "Slutprodukten har högre värde än utgångsmaterialen",
      upcyclingPoint2: "Kräver kreativitet och hantverksskicklighet",
      upcyclingPoint3: "Förlänger materialens livscykel avsevärt",
      upcyclingPoint4: "Skapar unika produkter med autentiska hållbarhetsreferenser",
      upcyclingSummary: "Till skillnad från återvinning (som ofta degraderar material) bevarar och förbättrar upcycling den inneboende kvaliteten hos textilier samtidigt som det adderar kreativt och ekonomiskt värde.",
      ctaTitle: "Kopplar Samman det Cirkulära Modeekosystemet",
      ctaDesc: "HIDNstock sammanför alla aktörer i den hållbara modets värdekedja. Oavsett om du har överskottsmaterial att sälja, eller letar efter secondhand- och deadstock-plagg för ditt nästa kreativa projekt, gör vår B2B-marknadsplats dessa kopplingar effektiva, professionella och meningsfulla.",
      ctaTagline: "Tillsammans omvandlar vi textilavfall till framtidens mode.",
    },
  },
  en: {
    nav: {
      howItWorks: "How It Works",
      admin: "Admin",
      getEarlyAccess: "Get Early Access",
      joinNewsletter: "Join Newsletter",
    },
    home: {
      heroBadgeLine1: "B2B Marketplace",
      heroBadgeLine2: "Buy & Sell Sorted Secondhand & Excess Inventory in Bulk",
      heroTitle1: "Buy & Sell",
      heroTitle2: "Sorted Secondhand &",
      heroTitle3: "Excess Inventory",
      heroTitle4: "in Bulk",
      heroCtaLearn: "Learn How It Works",
      heroCtaAccess: "Get Early Access",
      description: "A marketplace that connects fashion brands & sorting facilities with innovative redesigners and upcycling brands. Buy and sell sorted secondhand in bulk and excess inventory, anonymous if you prefer, or post remake projects to transform surplus materials into fashion of the future.",
      whatWeOffer: "What We Offer",
      whatWeDo: "What We Do",
      whatWeOfferDesc: "A streamlined platform connecting those with excess materials to those who transform them.",
      tabBrowseFull: "Buy & Sell Secondhand & Deadstock",
      tabBrowseShort: "Buy & Sell",
      tabRemakePrefix: "Post & Bid on ",
      tabRemake: "Remake Projects",
      marketplaceBadge: "Marketplace",
      marketplaceTitle: "Buy & Sell Sorted Secondhand & Deadstock Pieces",
      marketplaceDesc: "A marketplace where brands and sorting facilities list their excess inventory, and redesigners browse and purchase materials in bulk to scale their creative projects.",
      forSellers: "For Brands & Sorting Facilities",
      forSellersDesc: "List your deadstock pieces anonymously for brand protection or list your sorted secondhand to sell in bulk. Turn excess inventory into revenue while contributing to sustainable fashion.",
      sellerBenefit1: "Optional anonymous listings for brand protection",
      sellerBenefit2: "Monetize materials that would otherwise go to waste",
      sellerBenefit3: "Connect with verified buyers",
      forBuyers: "For Redesigners & Upcyclers",
      forBuyersDesc: "Access bulk quantities of pieces for your creative projects. Source sustainably and save time.",
      buyerBenefit1: "Bulk access to sorted secondhand & deadstock pieces",
      buyerBenefit2: "Quality-verified materials with detailed specs",
      buyerBenefit3: "Clear condition classification",
      projectBadge: "Project Collaboration",
      projectTitle: "Post & Bid on Remake Projects",
      projectDesc: "Brands post RFPs to transform their secondhand & deadstock into new collections, and skilled remakers bid on projects to bring them to life.",
      forBrandsPosting: "For Brands Posting Projects",
      forBrandsPostingDesc: "Post remake projects to hire skilled remakers and upcyclers to transform your secondhand & deadstock into new collections and unique pieces.",
      brandBenefit1: "Post detailed RFPs for remake collaborations",
      brandBenefit2: "Access network of skilled redesigners",
      brandBenefit3: "Turn failed productions into fashion of the future",
      forRemakers: "For Remakers & Upcyclers",
      forRemakersDesc: "Browse available remake projects and bid on opportunities to transform secondhand & deadstock into new fashion pieces.",
      remakerBenefit1: "Browse and bid on remake projects",
      remakerBenefit2: "Direct collaboration with major brands",
      remakerBenefit3: "Showcase your skills and grow your business",
      howItWorksTitle: "How It Works",
      howItWorksSubtitle: "For Redesigners, Upcyclers & Institutional Buyers",
      howItWorksDesc: "A simple three-step process to connect supply with demand.",
      step1Title: "Sign Up",
      step1Desc: "Create your account as a seller or buyer. Sellers? We'll guide you through a quick, hassle-free setup.",
      step2Title: "List or Browse",
      step2Desc: "Sellers list materials with photos and specs. Buyers browse and find what they need.",
      step3Title: "Connect & Transact",
      step3Desc: "Communicate securely, agree on terms, and complete transactions with confidence.",
      learnMore: "Learn how HIDNstock works",
      ctaTitle: "Get Early Access",
      ctaDesc: "Be the first to know when HIDNstock launches. Sign up to receive updates and exclusive early access.",
      ctaButton: "Sign Up Now",
      ctaPrivacy: "We respect your privacy. Unsubscribe at any time.",
      requestTitle: "Sell or source material",
      requestSubtitle: "Whether you're listing surplus materials or searching for something specific — we'll match you.",
      requestPlaceholder: "E.g. 500 kg deadstock denim, or looking for sorted secondhand t-shirts in bulk...",
      requestEmailPlaceholder: "Your email address",
      requestIntentLabel: "I'm here to",
      requestIntentSource: "Source material",
      requestIntentSell: "Sell material",
      requestGdpr: "I consent to my email and request being stored. We will only contact you when we find a match. You can unsubscribe at any time.",
      requestButton: "Sell or source material",
      requestDisclaimer: "We only reach out when we find a match — no spam, no noise.",
      requestSuccess: "Nice move. 👊",
      requestSuccessDesc: "We'll reach out when we spot a match.",
      requestError: "Something went wrong. Please try again.",
    },
    howItWorks: {
      badgeLine1: "B2B Platform",
      badgeLine2: "Sorted Secondhand & Deadstock",
      title: "How It Works",
      subtitle: "One platform, two services. Choose the path that fits your needs.",
      tabBrowseTitle: "Buy & Sell",
      tabBrowseSub: "Secondhand & Deadstock",
      tabRemakeTitle: "Post & Bid",
      tabRemakeSub: "Remake Projects",
      marketplaceBadge: "Marketplace",
      marketplaceTitle: "Buy & Sell Sorted Secondhand & Deadstock Pieces",
      marketplaceDesc: "A marketplace where brands and sorting facilities list their excess inventory, and redesigners browse and purchase materials.",
      iWantToSell: "I Want to Sell",
      iWantToBuy: "I Want to Buy",
      sellersTitle: "For Brands & Sorting Facilities",
      sellersDesc: "Turn excess inventory into revenue while supporting sustainability",
      sellStep1Title: "Create Your Account",
      sellStep1Desc: "Sign up and verify your business. Choose whether to list anonymously or showcase your brand.",
      sellStep2Title: "List Your Materials",
      sellStep2Desc: "With a simple integration and a click, upload photos and specifications of your sorted secondhand or deadstock pieces. Set quantities and pricing.",
      sellStep3Title: "Connect & Sell",
      sellStep3Desc: "Sell to verified buyers. Get reliable data for your sustainability report and turn waste into revenue.",
      sellBenefit1: "Monetize materials that would otherwise go to waste",
      sellBenefit2: "Optional anonymity for brand protection",
      sellBenefit3: "Keep your brand's status and avoid diluting",
      sellBenefit4: "Sustainability impact documentation",
      buyersTitle: "For Redesigners & Upcyclers",
      buyersDesc: "Access bulk materials for your creative projects",
      buyStep1Title: "Create Your Account",
      buyStep1Desc: "Sign up as a buyer and tell us about your business and what types of materials you're looking for.",
      buyStep2Title: "Browse & Discover",
      buyStep2Desc: "Search through available listings. Filter by material type, quantity, condition, and location.",
      buyStep3Title: "Connect & Purchase",
      buyStep3Desc: "Buy from verified sellers, save time and cost and secure the materials you need for your projects.",
      buyBenefit1: "Bulk access to quality materials",
      buyBenefit2: "Save time on sourcing",
      buyBenefit3: "Buy from verified sellers",
      buyBenefit4: "Verified material specifications",
      projectBadge: "Project Collaboration",
      projectTitle: "Post & Bid on Remake Projects",
      projectDesc: "Brands post RFPs to transform their deadstock into new collections, and skilled remakers bid on projects.",
      iWantToPost: "I Want to Post",
      iWantToBid: "I Want to Bid",
      brandsTitle: "For Brands Posting Projects",
      brandsDesc: "Transform your secondhand & deadstock into new collections",
      postStep1Title: "Create Your Project",
      postStep1Desc: "Describe your secondhand & deadstock, the quantity available, and your vision for the remake project.",
      postStep2Title: "Receive Bids",
      postStep2Desc: "Skilled remakers and upcyclers will submit proposals with their creative ideas and pricing.",
      postStep3Title: "Collaborate & Create",
      postStep3Desc: "Select your preferred remaker, finalize terms, and work together to create new fashion pieces.",
      postBenefit1: "Turn failed productions into new collections",
      postBenefit2: "Access skilled remake professionals",
      postBenefit3: "Control the creative direction",
      postBenefit4: "Sustainable solution for excess inventory",
      remakersTitle: "For Remakers & Upcyclers",
      remakersDesc: "Bid on projects and grow your business",
      bidStep1Title: "Browse Projects",
      bidStep1Desc: "Explore available remake projects from brands looking to transform their secondhand & deadstock.",
      bidStep2Title: "Submit Your Bid",
      bidStep2Desc: "Propose your creative vision, timeline, and pricing for the project.",
      bidStep3Title: "Win & Deliver",
      bidStep3Desc: "If selected, collaborate with the brand to bring your creative vision to life.",
      bidBenefit1: "Direct access to brand collaborations",
      bidBenefit2: "Steady stream of project opportunities",
      bidBenefit3: "Save time on sales meetings",
      bidBenefit4: "Build your professional portfolio",
      benefits: "Benefits",
      trustTitle: "Built on Trust",
      trustDesc: "Every transaction on HIDNstock is designed with security and transparency in mind. Verified accounts, secure communication, and clear terms protect all parties.",
    },
    about: {
      title: "About HIDNstock",
      subtitle: "Building B2B infrastructure for circular textiles",
      metaTitle: "About HIDNstock - B2B Marketplace for Circular Textiles",
      metaDesc: "HIDNstock was founded to bridge the gap between deadstock materials and circular fashion businesses. Learn about our mission to create B2B infrastructure for sustainable textiles.",
      kicker: "Our manifesto",
      hero: "We don't do waste. We do value.",
      lead: "HIDNstock was born out of frustration. We've spent years in the trenches of the fashion industry — from the design studio to the factory floor — and we saw the same broken pattern everywhere.",
      heading1: "Why we built this",
      p1: "HIDNstock was born out of frustration. We've spent years in the trenches of the fashion industry — from the design studio to the factory floor — and we saw the same broken pattern everywhere: big brands and sorting facilities are drowning in unsold inventory and high-quality secondhand bulk, while talented remakers and designers are starving for the materials they need to scale.",
      p2: "The industry is stuck in a linear loop, and frankly, it's outdated. We decided to stop complaining and start building the infrastructure that actually connects these worlds.",
      heading2: "Why we exist",
      p3: "We're a team of fashion veterans and digital architects. We've seen firsthand how valuable textiles — whether they are brand-new deadstock from a major label or high-quality secondhand bulk from sorting facilities — often end up incinerated or downcycled simply because the industry lacks a professional, scalable marketplace. The material is already here; the problem has always been the lack of a bridge.",
      bridge: "So, we built that bridge.",
      heading3: "The HIDNstock way",
      p4: "HIDNstock is the B2B backbone for circular textiles. We move surplus inventory and sorted bulk from \"liabilities\" to \"assets\" in a way that is traceable, brand-safe, and profitable.",
      p4b: "We don't believe in just \"recycling\" materials down to scrap. We believe in keeping the value alive. Whether it's finished garments, deadstock fabric, or curated secondhand bulk, we ensure that what has already been produced gets a second life in the hands of someone who will actually use it.",
      heading4: "The future is circular",
      p5: "EU regulations are shifting, and the days of incinerating unsold goods are numbered. Brands and sorting facilities now face a simple choice: adapt to a circular reality or get left behind. We're here for the ones who choose to adapt — the innovators who know that the future of fashion isn't about producing more, but about maximizing the brilliance of what we already have.",
      cta: "Join us in building a more resilient industry. One surplus batch at a time.",
    },
    contact: {
      title: "Contact Us",
      subtitle: "Have questions? We'd love to hear from you.",
      getInTouch: "Get in Touch",
      getInTouchDesc: "We'll respond as soon as possible.",
      name: "Name *",
      namePlaceholder: "Your name",
      email: "Email *",
      emailPlaceholder: "your@email.com",
      company: "Company (optional)",
      companyPlaceholder: "Your company name",
      messageLbl: "Message *",
      messagePlaceholder: "Tell us how we can help...",
      sending: "Sending...",
      sendMessage: "Send Message",
      successTitle: "Message sent!",
      successDesc: "Thank you for reaching out. We'll get back to you soon.",
      errorTitle: "Error",
      errorDesc: "Failed to send message. Please try again.",
    },
    footer: {
      description: "The B2B marketplace connecting brands and sorting facilities with redesigners and upcyclers through secondhand & deadstock pieces.",
      platform: "Platform",
      howItWorks: "How It Works",
      whatDoesItMean: "What Does It Mean?",
      company: "Company",
      aboutHidnstock: "About HIDNstock",
      contact: "Contact",
      rights: "© 2025 HIDNstock. All rights reserved.",
      tagline: "Transforming textile waste into opportunity",
      newsletter: "Newsletter",
      press: "Press",
    },
    newsletter: {
      title: "Want to join our love letter?",
      description: "Get updates on how to scale a remake business, get a sneak peek of the latest listings, remake inspo and the latest HIDNstock updates straight to your inbox.",
      pageIntro: "Get updates on how to scale a remake business, get a sneak peek of the latest listings, remake inspo and the latest HIDNstock updates straight to your inbox.",
      emailLabel: "Email",
      emailPlaceholder: "your@email.com",
      gdprText: "I agree that HIDNstock may store my email and send me newsletters and service updates. I can unsubscribe at any time.",
      signingUp: "Signing up...",
      signUp: "Subscribe",
      privacyNote: "We respect your privacy. Your data is handled according to GDPR.",
      successTitle: "Thank you!",
      successDesc: "You're subscribed to our newsletter.",
      close: "Close",
      alreadySignedUpTitle: "Already signed up",
      alreadySignedUpDesc: "This email is already on the list!",
      successToastTitle: "Success!",
      successToastDesc: "You're signed up for the newsletter.",
      errorTitle: "Something went wrong",
      errorDesc: "Please try again later",
    },
    earlyAccess: {
      title: "Get Early Access",
      description: "Be the first to know when HIDNstock launches.",
      emailLabel: "Email",
      emailPlaceholder: "your@email.com",
      iAmA: "I am a...",
      brand: "Brand",
      sortingFacility: "Sorting Facility",
      remakerUpcycler: "Remaker / Upcycler",
      gdprText: "I agree that HIDNstock may store my email and contact me about the launch and service updates. I can unsubscribe at any time.",
      signingUp: "Signing up...",
      signUp: "Sign Up",
      privacyNote: "We respect your privacy. Your data is handled according to GDPR.",
      successTitle: "You're on the List!",
      successDesc: "Thank you for signing up. We'll be in touch soon with updates.",
      close: "Close",
      alreadySignedUpTitle: "Already signed up",
      alreadySignedUpDesc: "This email is already on the list!",
      successToastTitle: "Success!",
      successToastDesc: "You're on the list! Check your inbox for a confirmation.",
      errorTitle: "Something went wrong",
      errorDesc: "Please try again later",
    },
    whatDoesItMean: {
      badge: "Glossary & Definitions",
      title: "What Does It Mean?",
      subtitle: "Understanding the terminology of sustainable fashion and circular textile economy. Learn what deadstock, sorted secondhand, upcycling, and remake mean in the context of our B2B marketplace.",
      b2bTitle: "B2B (Business-to-Business) platform for sustainable textiles",
      b2bDesc1: "HIDNstock is a <strong>B2B (Business-to-Business)</strong> platform designed exclusively for transactions between companies—not individual consumers. We enable professional, large-scale sourcing and resale of sustainable textiles across the fashion and textile industry.",
      b2bDesc2: "Our platform connects key actors in the circular fashion supply chain:",
      b2bBullet1: "<strong>Fashion brands</strong> with excess inventory, deadstock, or overproduction",
      b2bBullet2: "<strong>Textile sorting facilities</strong> processing secondhand and post-consumer materials",
      b2bBullet3: "<strong>Redesigners and upcyclers</strong> sourcing materials for circular and creative production",
      b2bBullet4: "<strong>Manufacturers</strong> looking for reliable, sustainable fabric and material sources",
      b2bDesc3: "By focusing on B2B textile transactions, HIDNstock enables bulk volumes, consistent quality standards, full material traceability, and efficient logistics. This creates a scalable infrastructure for circular fashion, textile reuse, and sustainable manufacturing.",
      deadstockTitle: "What is deadstock in the fashion industry?",
      deadstockSubtitle: "Understanding Deadstock",
      deadstockAlias: "Also known as: NOS, Old Stock, Overstock",
      deadstockDesc: "<strong>Deadstock</strong> refers to unsold inventory, leftover fabrics, or finished garments that were never sold to consumers. In the fashion and textile industry, deadstock accumulates when:",
      deadstockReason1: "Brands produce more items than the market demands",
      deadstockReason2: "Retail orders are cancelled before or after production",
      deadstockReason3: "Seasonal collections don't sell through",
      deadstockReason4: "Fabric rolls remain unused after production runs",
      complexityTitle: "The complexity of deadstock",
      complexityDesc1: "Deadstock is often viewed as a symptom of structural challenges in the fashion industry. While some argue that reselling deadstock risks normalizing overproduction, the reality is that significant volumes already exist today—and will continue to do so until forecasting, production planning, and supply chain technologies mature further.",
      complexityDesc2: "Until that transition is complete, deadstock represents both an <strong>environmental challenge</strong> and a <strong>responsibility</strong>.",
      transitionalTitle: "HIDNstock as a transitional solution",
      transitionalDesc1: "HIDNstock is built as a transitional solution. Our platform does not aim to justify overproduction, but to prevent existing materials from becoming waste. By enabling controlled, traceable B2B redistribution, brands can take responsibility for surplus inventory while supporting circular fashion practices.",
      transitionalDesc2: "Through HIDNstock, brands gain the opportunity to:",
      transitionalBenefit1: "<strong>Monetize existing deadstock</strong> without diluting their core brand",
      transitionalBenefit2: "<strong>Reduce environmental impact</strong> by extending material lifecycles",
      transitionalBenefit3: "<strong>Collaborate with redesigners, remakers, and upcyclers</strong> on new collections",
      transitionalBenefit4: "<strong>Turn surplus materials</strong> into creative, sustainable value",
      transitionalQuote: "Our long-term ambition is a fashion industry with minimal overproduction. Until then, HIDNstock provides one practical, scalable way to turn deadstock into a force for positive change.",
      sortedTitle: "Sorted Secondhand Explained",
      sortedSubtitle: "What is Sorted Secondhand?",
      sortedBadge: "Professional-grade pre-owned textiles",
      sortedDesc: "<strong>Sorted secondhand</strong> refers to pre-worn garments that have been collected, inspected, and categorized by professional sorting facilities. Unlike random thrift store finds, sorted secondhand is:",
      categorizedBy: "Categorized by:",
      cat1: "Material type (cotton, wool, denim, etc.)",
      cat2: "Garment category (jackets, shirts, trousers)",
      cat3: "Quality grade (A, B, C)",
      cat4: "Color family",
      cat5: "Season suitability",
      benefitsFor: "Benefits for B2B buyers:",
      ben1: "Consistent quality within batches",
      ben2: "Bulk quantities available",
      ben3: "Clear condition grading",
      ben4: "Reduced sourcing time",
      ben5: "Predictable material characteristics",
      sortedSummary: "On HIDNstock, sorting facilities list their processed inventory, allowing redesigners and upcyclers to efficiently source specific types of garments in bulk quantities—something nearly impossible through traditional secondhand channels.",
      remakeTitle: "Remake, Redesign & Upcycling",
      whatIsRemake: "What is Remake?",
      remakeBadge: "Commissioned transformation",
      remakeDesc: "<strong>Remake</strong> is the process where brands commission skilled artisans or companies to transform their excess inventory into new products. On HIDNstock:",
      remakePoint1: "Brands post <strong>Remake Projects</strong> describing their materials and vision",
      remakePoint2: "Qualified remakers bid on these projects with proposals",
      remakePoint3: "Selected remakers transform the materials into new fashion pieces",
      remakePoint4: "Brands get unique new products; remakers get paid for their skills",
      remakeSummary: "This collaborative approach keeps materials in circulation and creates value for all parties.",
      whatIsRedesign: "What is Redesign?",
      redesignBadge: "Creative reinterpretation",
      redesignDesc: "<strong>Redesign</strong> involves taking existing garments or materials and reimagining them with a new design perspective. Redesigners:",
      redesignPoint1: "Deconstruct original pieces to create new patterns",
      redesignPoint2: "Combine multiple source garments into single new items",
      redesignPoint3: "Apply new techniques (dyeing, printing, embellishment)",
      redesignPoint4: "Create limited-edition or one-of-a-kind pieces",
      redesignSummary: "Redesign bridges the gap between waste reduction and creative fashion, producing unique items with compelling sustainability stories.",
      whatIsUpcycling: "What is Upcycling?",
      upcyclingBadge: "Value elevation",
      upcyclingDesc: "<strong>Upcycling</strong> is the creative process of transforming discarded materials or unwanted products into new items of <em>higher</em> quality or value. Key characteristics:",
      upcyclingPoint1: "The end product has greater value than the source materials",
      upcyclingPoint2: "Requires creativity and craftsmanship",
      upcyclingPoint3: "Extends material lifecycle significantly",
      upcyclingPoint4: "Creates unique products with authentic sustainability credentials",
      upcyclingSummary: "Unlike recycling (which often degrades materials), upcycling preserves and enhances the inherent quality of textiles while adding creative and economic value.",
      ctaTitle: "Connecting the Circular Fashion Ecosystem",
      ctaDesc: "HIDNstock brings together all players in the sustainable fashion value chain. Whether you have excess materials to sell, or you're looking to source secondhand & deadstock pieces for your next creative project, our B2B marketplace makes these connections efficient, professional, and impactful.",
      ctaTagline: "Together, we're transforming textile waste into fashion of the future.",
    },
  },
} as const;
